'use client';

import type { ReactNode } from 'react';

import { OPEN_CHAT_EVENT } from './chat-widget';

/**
 * A styled button that opens the Selenos chat widget by dispatching
 * OPEN_CHAT_EVENT. Lets the (server-component) landing page wire its
 * "Talk to Selenos" CTAs to the floating chat without becoming a client
 * component itself. Styling is passed in so it can match any CTA variant.
 */
export function OpenChatButton({
  className,
  children,
  onActivate,
}: {
  className?: string;
  children: ReactNode;
  /** Optional side effect to run when the button opens the chat (e.g. close a menu). */
  onActivate?: () => void;
}) {
  return (
    <button
      type="button"
      onClick={() => {
        window.dispatchEvent(new Event(OPEN_CHAT_EVENT));
        onActivate?.();
      }}
      className={className}
    >
      {children}
    </button>
  );
}
